import { render } from "./PartnerPage.vue?vue&type=template&id=341663f8&scoped=true"
import script from "./PartnerPage.vue?vue&type=script&lang=js"
export * from "./PartnerPage.vue?vue&type=script&lang=js"

import "./PartnerPage.vue?vue&type=style&index=0&id=341663f8&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-341663f8"]])

export default __exports__